module.exports = __webpack_public_path__ + "img/politika.c48e3be3.svg";